import * as React from 'react';
import { OBJECT_TYPES } from '../../../../constants/filters';
import { EObjectType } from '../../../../types/filters';
import { Select } from '../../../Select';

interface IObjectTypeProps {
  value: EObjectType[];
  onChange(value: EObjectType[]): void;
}

export const ObjectType: React.FC<IObjectTypeProps> = ({ value, onChange }) => {
  return (
    <Select
      multiple
      allowEmpty={false}
      placeholder="Тип"
      options={OBJECT_TYPES}
      value={value}
      onChange={onChange}
      buttonParams={{ label: 'Тип объекта' }}
    />
  );
};
